import { FC } from "react";
import { TColumnData } from "../../../../components/tables/table_column";
import Table from "../../../../components/tables/table";
import { getDateTimeView } from "../../../../helpers/datetime";
import { getCurrencyNumberWithOutSymbol } from "../../../../helpers/get-currency-number";
import {
  copyText,
  getPayoutStatus,
  getPayoutStatusColor,
} from "../../../../helpers/payouts";
import copyIcon from "../../../../assets/images/copy.svg";
import { ArrowForwardIos } from "@mui/icons-material";
import { TPayoutFilters, TPayoutInfo } from "../bloc/payoutsSlice";
import { getUpdatedPayouts } from "../functions/payouts_functions";

const PayoutsTable: FC<{
  payouts: TPayoutInfo[];
  onClick: (index: number) => void;
  searchText: string;
  isCardCollpased: boolean;
  filters: TPayoutFilters;
}> = ({ payouts, onClick, searchText, isCardCollpased, filters }) => {
  const columns: TColumnData[] = [
    { text: "#", width: 5 },
    { text: "Trade Id / Loan Id", width: 10 },
    { text: "UTR", width: 15 },
    { text: "Created At", width: 12 },
    { text: "Type", width: 7 },
    { text: "Receiver", width: 13 },
    { text: "Amount(₹)", width: 10, classes: "justify-end" },
    { text: "Payout Id", width: 18 },
    { text: "Status", width: 10 },
  ];

  const _buildRow = (index: number, payout: TPayoutInfo) => {
    return [
      <>{index + 1}</>,
      <>{payout.prodId}</>,
      <>{payout.utr}</>,
      <>{getDateTimeView(payout.createdOn)}</>,
      <>{payout.type}</>,
      <>{payout.receiver}</>,
      <div className="text-end">
        {getCurrencyNumberWithOutSymbol(payout.amount)}
      </div>,
      <div>
        {payout.payoutId && (
          <div className="flex justify-between">
            <span> {payout.payoutId}</span>
            <img
              src={copyIcon}
              height={10}
              className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                copyText(payout.payoutId);
              }}
            />
          </div>
        )}
      </div>,
      <div className="flex justify-between">
        <span className={getPayoutStatusColor(payout.status)}>
          {getPayoutStatus(payout.status)}
        </span>
        <div className="br-100 icon_bg w-[25px] h-[25px] flex items-center justify-center color-inactive">
          <ArrowForwardIos
            style={{
              fontSize: 16,
              color: "color-inactive",
            }}
          />
        </div>
      </div>,
    ];
  };

  const _getPayoutsList = () => {
    let updatedPayouts = getUpdatedPayouts(searchText, payouts, filters);
    return updatedPayouts;
  };

  return (
    <Table
      columns={columns}
      data={_getPayoutsList().map((payout, index) => _buildRow(index, payout))}
      maxHeight={
        isCardCollpased ? "calc(100vh - 17rem)" : "calc(100vh - 21rem)"
      }
      onRowClick={onClick}
    />
  );
};

export default PayoutsTable;
